import { selectLocation } from "./i18n";

export const setLocale = (language: any) => {
    const actualLocale = getLocale();
    if (language != actualLocale) {
        localStorage.setItem("locale", language); 
        window.location.reload();
    }
    return
}

export const getLocale = () => {
    return localStorage.getItem("locale") ?? "br";
}

export const getLanguage = () => {
    return selectLocation(localStorage.getItem("locale") ?? "br");
}